import { DiagramQuestionScreen } from '../components/business/DiagramQuestionScreen';

export default function DiagramQuestionPage() {
  return <DiagramQuestionScreen />;
}
